import React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { RootLayout } from '../../../root/root.layout'
import { State, renderReadSpeaker } from '../../cmsPage.widget'

export const widget404 = (s:State):Widget<Updater<State>> => fromJSX(_ => 
  <RootLayout.Error kind='notFound' showReadspeaker={renderReadSpeaker(s)}/>
)